<template>
  <div class="photovoltaicMain">
    <div class="photovoltaicContent">
      <div class="leftWrap">
        <div class="siteInfo comWrap">
          <div class="comHeader">
            <div class="title">
              <p @click="$router.push('/photovoltaicSystem')">逆变器信息</p>
            </div>
          </div>
          <div class="comContent siteContent">
            <div style="width: 100%">
              <ul>
                <li v-for="(v, i) in infoList" :key="i">
                  <h5 :style="{ color: colorList[i] }">{{ v.value }}</h5>
                  <p>{{ v.name }}</p>
                </li>
              </ul>
              <div class="row">
                <p>
                  电站数量/个 <span>{{ powerStationCount }}</span>
                </p>
                <p>
                  装机总功率/kwp <span>{{ installedPower }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="eleInfo comWrap">
          <div class="comHeader">
            <div class="title">
              <p @click="$router.push('/photovoltaicSystem')">
                发电及光伏用电信息
              </p>
            </div>
          </div>
          <div class="comContent">
            <div class="tabContent">
              <ul>
                <li></li>
                <li style="color: #16e9f4">发电 kw·h</li>
                <li style="color: #b4a92e">用电 kw·h</li>
                <li style="color: #8b91f6">并网 kw·h</li>
              </ul>
              <ul v-for="(v, i) in eleInfoList" :key="i">
                <li>{{ v.name }}</li>
                <li>{{ v.genEc.toFixed(2) }}</li>
                <li>{{ v.projectEc.toFixed(2) }}</li>
                <li>{{ v.upEc.toFixed(2) }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="powerTrend comWrap">
          <div class="comHeader">
            <div class="title">
              <p @click="$router.push('/photovoltaicStation')">发电趋势</p>
            </div>
            <ul>
              <li
                v-for="(v, i) in dataList"
                :key="i"
                :class="trendActive == i ? 'activeLi' : ''"
                @click="changeDate('trendActive', i)"
              >
                {{ v.name }}
              </li>
            </ul>
          </div>
          <div class="comContent">
            <PublicEcharts
              :id="'chartsGrowth'"
              :chartsData="powerTrendCharts"
              :type="'darkBlueLine'"
            />
          </div>
        </div>
      </div>
      <div class="contentWrap">
        <ul class="listBox">
          <!-- <li v-for="(v, i) in tolList" :key="i">
            <h5>{{ v.value }}</h5>
            <p>
              {{ v.name }} <span>{{ v.unit }}</span>
            </p>
          </li> -->
        </ul>
        <div class="imgBox">
          <img
            v-if="picCenterUrl"
            style="width: 100%; height: 100%"
            :src="picCenterUrl"
          />
        </div>
        <div class="analysis comWrap">
          <div class="comHeader">
            <div class="title">
              <p @click="$router.push('/photovoltaicBenefits')">用电分析</p>
            </div>
            <ul>
              <li
                v-for="(v, i) in dataList"
                :key="i"
                :class="analysisActive == i ? 'activeLi' : ''"
                @click="changeDate('analysisActive', i)"
              >
                {{ v.name }}
              </li>
            </ul>
          </div>
          <div class="comContent" style="display: flex; align-items: center">
            <div class="ringBox">
              <PublicEcharts
                :id="'analysisRose'"
                :chartsData="roseCharts"
                :type="'darkRose'"
              />
            </div>
            <div class="lineBox">
              <PublicEcharts
                :id="'stackedColumn'"
                :chartsData="stackedLine"
                :type="'darkStackedColumnBar'"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="rightWrap">
        <div class="meteorological comWrap">
          <div class="comHeader">
            <div class="title">
              <p @click="$router.push('/photovoltaicStation')">气象监测</p>
            </div>
            <p class="txtBox">更新时间:{{ new Date().toLocaleString() }}</p>
          </div>
          <div class="comContent" style="display: flex; align-items: center">
            <ul>
              <li v-for="v in METMonitorList" :key="v.key">
                <p>{{ v.name }}</p>
                <h5>{{ v.value }}</h5>
              </li>
            </ul>
          </div>
        </div>
        <div class="giveAlarm comWrap">
          <div class="comHeader">
            <div class="title">
              <p
                @click="
                  $router.push({
                    name: 'photovoltaicDevOps',
                    params: { id: '告警' },
                  })
                "
              >
                告警分析
              </p>
            </div>
            <ul>
              <li
                v-for="(v, i) in dataList"
                :key="i"
                :class="alarmActive == i ? 'activeLi' : ''"
                @click="changeDate('alarmActive', i)"
              >
                {{ v.name }}
              </li>
            </ul>
          </div>
          <div class="comContent">
            <PublicEcharts
              :id="'giveAlarm'"
              :chartsData="giveAlarmData"
              :type="'darkRing'"
            />
          </div>
        </div>
        <div class="ecData comWrap">
          <div class="comHeader">
            <div class="title">
              <p @click="$router.push('/photovoltaicBenefits')">节能降碳</p>
            </div>
            <ul>
              <li
                v-for="(v, i) in dataList"
                :key="i"
                :class="ecActive == i ? 'activeLi' : ''"
                @click="changeDate('ecActive', i)"
              >
                {{ v.name }}
              </li>
            </ul>
          </div>
          <div class="comContent">
            <PublicEcharts
              :id="'ecData'"
              :chartsData="ecDataCharts"
              :type="'darkHorizontalBar'"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt, getProjectVal, getUserInfoVal } from "@/assets/js/utils";
import PublicEcharts from "@/components/PublicEcharts";
import { ANGLEDEFAULT, WEATHERDEFAULT } from "@/assets/js/const";
export default {
  components: {
    PublicEcharts,
  },
  data() {
    return {
      colorList: ["#16E9F4", "#96A1BB", "#C7BB34", "#51A4F6"],
      infoList: [
        { name: "在线", value: null },
        { name: "离线", value: null },
        { name: "故障", value: null },
        { name: "实时功率/kw", value: null },
      ],
      powerStationCount: null,
      installedPower: null,
      tolList: [
        { name: "上月用电", value: 70.2, unit: "kw·h" },
        { name: "实际电费", value: 34.2, unit: "万元" },
        { name: "累计节约电费", value: 65789, unit: "万元" },
        { name: "累计并网收益", value: 70.2, unit: "万元" },
      ],
      ecDataCharts: {
        unit: "吨",
        dataArr: [],
      }, //节能降碳
      powerTrendCharts: {
        unit: "kw·h",
        xData: [],
        dataArr: [],
      }, //发电趋势
      roseCharts: { unit: "", dataArr: [], labelType: "percentage" }, //用电分析玫瑰图
      stackedLine: {
        unit: "kw·h",
        xData: [],
        dataArr: [],
      },
      giveAlarmData: {
        unit: "个",
        dataArr: [],
      }, //告警分析
      eleInfoList: [],
      trendActive: 0,
      alarmActive: 0,
      ecActive: 0,
      analysisActive: 0,
      dataList: [
        {
          name: "今日",
          value: "hour",
          date: new Date(dateFtt("yyyy-MM-dd 00:00:00", new Date())).getTime(),
        },
        {
          name: "本月",
          value: "day",
          date: new Date(dateFtt("yyyy-MM-01 00:00:00", new Date())).getTime(),
        },
        {
          name: "本年",
          value: "month",
          date: new Date(dateFtt("yyyy-01-01 00:00:00", new Date())).getTime(),
        },
      ],
      METMonitorList: [
        { name: "天气", value: "", key: "Weather" },
        { name: "温度", value: "", key: "Temperature" },
        { name: "设备温度", value: "", key: "DeviceTem" },
        { name: "大气压强", value: "", key: "Pressure" },
        { name: "湿度", value: "", key: "Humidity" },
        { name: "辐照强度", value: "", key: "Radiation" },
        { name: "风速", value: "", key: "WindSpeed" },
        { name: "风向", value: "", key: "WindDirection" },
      ],
      picCenterUrl: "",
    };
  },
  methods: {
    changeDate(type, index) {
      this[type] = index;
      if (type == "trendActive") {
        this.getPowerTrend();
      } else if (type == "analysisActive") {
        this.getECAnalysis();
      } else if (type == "ecActive") {
        this.getEnergySaveInfo();
      } else if (type == "alarmActive") {
        this.getAlarmAnalysis();
      }
    },
    async getPowerStationInfo() {
      let res = await api.PVOSPowerStationPSInfo({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });
      if (res && res.data.code == 200) {
        let data = res.data.data;
        this.infoList[0].value = data.inverterState.active;
        this.infoList[1].value = data.inverterState.notActive;
        this.infoList[2].value = data.inverterState.alarmNum;
        this.infoList[3].value = data.power ? data.power.toFixed(2) : null;
        this.powerStationCount = data.powerStationCount;
        this.installedPower = data.InstalledPower;
      }
    },

    async getEleInfo(data) {
      let res = await api.PVOSEleInfo({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: data.startTime,
        endTime: new Date().getTime(),
        period: data.date,
      });
      return {
        name: data.name,
        ...res.data.data,
      };
    },
    handleEleInfo() {
      let params = [
        {
          name: "当日",
          date: "hour",
          startTime: new Date(
            dateFtt("yyyy-MM-dd 00:00:00", new Date())
          ).getTime(),
        },
        {
          name: "当月",
          date: "day",
          startTime: new Date(
            dateFtt("yyyy-MM-01 00:00:00", new Date())
          ).getTime(),
        },
        {
          name: "当年",
          date: "month",
          startTime: new Date(
            dateFtt("yyyy-01-01 00:00:00", new Date())
          ).getTime(),
        },
      ];
      Promise.all(params.map((v) => this.getEleInfo(v))).then((res) => {
        this.eleInfoList = res;
      });
    },
    async getECPublicFun(params) {
      let res = await api.PVOSPowerTrend({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: params.date,
        endTime: new Date().getTime(),
        period: params.value,
        needPeriodEc: params.needPeriodEc,
      });
      let data = [];
      if (res && res.data.code == 200) {
        let obj = res.data.data.tsValue;
        for (let key in obj) {
          let row = Object.assign(obj[key], {
            time:
              params.value == "hour"
                ? dateFtt("hh时", new Date(Number(key)))
                : params.value == "day"
                ? dateFtt("dd日", new Date(Number(key)))
                : dateFtt("MM月", new Date(Number(key))),
            ts: Number(key),
          });
          data.push(row);
        }
        data.sort(function (a, b) {
          return a.ts - b.ts;
        });
      }
      return { res: res.data.data, data };
    },

    getPowerTrend() {
      this.powerTrendCharts.xData = [];
      this.powerTrendCharts.dataArr = [{ name: "发电量", data: [] }];
      let params = Object.assign(this.dataList[this.trendActive], {
        needPeriodEc: false,
      });
      this.getECPublicFun(params).then((res) => {
        res.data.map((v) => {
          this.powerTrendCharts.xData.push(v.time);
          this.powerTrendCharts.dataArr[0].data.push(
            v.EC_Hour ? v.EC_Hour.toFixed(2) : null
          );
        });
      });
    },
    getECAnalysis() {
      this.roseCharts.dataArr = [
        { name: "光伏", value: null, key: "Sum_EC_Hour" },
        { name: "谷", value: null, key: "Sum_Valley_EC_Hour" },
        { name: "峰", value: null, key: "Sum_Peek_EC_Hour" },
        { name: "平", value: null, key: "Sum_Flat_EC_Hour" },
        { name: "尖", value: null, key: "Sum_Tip_EC_Hour" },
      ];
      this.stackedLine.xData = [];
      this.stackedLine.dataArr = [
        {
          name: "光伏",
          key: "EC_Hour",
          data: [],
        },
        {
          name: "谷电",
          key: "Valley_EC_Hour",
          data: [],
        },
        {
          name: "峰电",
          key: "Peek_EC_Hour",
          data: [],
        },
        {
          name: "平电",
          key: "Flat_EC_Hour",
          data: [],
        },
        {
          name: "尖电",
          key: "Tip_EC_Hour",
          data: [],
        },
      ];

      let params = Object.assign(this.dataList[this.analysisActive], {
        needPeriodEc: true,
      });
      this.getECPublicFun(params).then((res) => {
        this.roseCharts.dataArr.map((v) => {
          v.value = res.res[v.key] ? res.res[v.key].toFixed(2) : 0;
        });
        this.roseCharts.dataArr = this.roseCharts.dataArr.filter((v) => {
          return v.value;
        });
        res.data.map((v) => {
          this.stackedLine.xData.push(v.time);
          this.stackedLine.dataArr.map((item) => {
            item.data.push(v[item.key] ? v[item.key].toFixed(2) : 0);
          });
        });
      });
    },
    async getEnergySaveInfo() {
      this.ecDataCharts.dataArr = [
        { key: "CO2Rate", name: "减少CO2排放", value: null },
        { key: "CarbonRate", name: "减少碳排放", value: null },
        { key: "KGCERage", name: "节约标准煤", value: null },
      ];
      let params = this.dataList[this.ecActive];
      let res = await api.PVOSEnergySaveInfo({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: params.date,
        endTime: new Date().getTime(),
        period: params.value,
      });
      if (res && res.data.code == 200) {
        this.ecDataCharts.dataArr.map((v) => {
          v.value = res.data.data[v.key] ? res.data.data[v.key].toFixed(2) : 0;
        });
      }
    },
    async getAlarmAnalysis() {
      this.giveAlarmData.dataArr = [];
      let params = this.dataList[this.alarmActive];
      let res = await api.PVOSAlarmAnalysis({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        startTime: params.date,
        endTime: new Date().getTime(),
      });
      if (res && res.data.code == 200) {
        let data = res.data.data;
        if (Object.keys(data).length == 0) {
          this.giveAlarmData.dataArr.push({ name: "", value: 0 });
        }
        for (let key in data) {
          this.giveAlarmData.dataArr.push({ name: key, value: data[key] });
        }
      }
    },
    async getMETMonitor() {
      let res = await api.PVOSMETMonitor({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
      });

      if (res && res.data.code == 200) {
        this.METMonitorList.map((v) => {
          v.value = res.data.data[0][v.key];
          if (v.key === "Weather") {
            v.value = WEATHERDEFAULT?.[v.value] || "-";
          } else if (v.key === "WindDirection") {
            v.value = ANGLEDEFAULT?.[v.value] || "-";
          }
        });
      }
    },
    async getPicCenter() {
      let res = await api.EMGetPic(
        {
          keys: "pvResourceUrl",
        },
        getProjectVal("Id")
      );
      if (res?.status == 200) {
        const newvalue = res?.data?.[0]?.value;
        if (newvalue) {
          this.picCenterUrl = `${newvalue}?tenant_id=${getUserInfoVal(
            "tenantId"
          )}`;
        }
      }
    },
  },
  created() {
    this.getPicCenter();
    this.getPowerStationInfo();
    this.handleEleInfo();
    this.getPowerTrend();
    this.getECAnalysis();
    this.getEnergySaveInfo();
    this.getAlarmAnalysis();
    this.getMETMonitor();
  },
};
</script>

<style lang="scss" scoped>
.photovoltaicMain {
  width: 100%;
  height: 100%;
  background: #050b1f;
  overflow: hidden;
  @include setFlexCenter;
  .photovoltaicContent {
    width: 97%;
    height: 96%;
    @include setFlexBetween;
    .comWrap {
      .comHeader {
        height: 35px;
        @include setFlexBetween;
        .title {
          height: 100%;
          background: url("~@/assets/images/guangfu/header.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          padding-right: 50px;
          display: flex;
          align-items: center;
          p {
            font-weight: bold;
            font-size: 15px;
            color: #fff;
            position: relative;
            margin-left: 20px;
            text-indent: 15px;
            border-left: 3px solid #28cccb;
            cursor: pointer;
          }
        }
        ul {
          display: flex;
          color: #aeb2c2;
          li {
            padding: 5px 12px;
            font-size: 14px;
            border-bottom: 1px solid transparent;
            cursor: pointer;
          }
          .activeLi {
            color: #16e9f4;
            border-image: linear-gradient(
                270deg,
                rgba(49, 246, 250, 0),
                rgba(49, 246, 250, 0.68),
                rgba(22, 233, 244, 0)
              )
              1 1;
          }
        }
        .txtBox {
          color: #cccfd4;
        }
      }
      .comContent {
        height: calc(100% - 46px);
        width: 100%;
        background: url("~@/assets/images/guangfu/wrap.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .leftWrap {
      width: 25%;
      height: 100%;
      @include setFlexColumn;
      justify-content: space-between;
      .siteInfo {
        width: 100%;
        height: 25%;
        .siteContent {
          @include setFlexCenter;
          ul {
            width: 98%;
            margin: 0 auto 20px;
            @include setFlexBetween;
            li {
              width: 25%;
              text-align: center;
              h5 {
                font-size: 22px;
              }
              p {
                color: #e0e3e8;
              }
            }
          }
          .row {
            width: 95%;
            margin: 0 auto;
            @include setFlexAround;
            p {
              color: #838996;
              span {
                display: inline-block;
                color: #e0e3e8;
                font-size: 16px;
              }
            }
          }
        }
      }
      .eleInfo {
        width: 100%;
        height: 32%;
        .tabContent {
          width: 95%;
          height: 100%;
          margin: 0 auto;
          ul {
            height: 23%;
            @include setFlexBetween;
            li {
              width: 25%;
              text-align: center;
              color: #dde6e9;
            }
            li:first-child {
              font-size: 14px;
              font-weight: bold;
              color: #7ba0bc;
            }
          }
          ul:first-child {
            font-size: 15px;
          }
        }
      }
      .powerTrend {
        width: 100%;
        height: 40%;
      }
    }
    .contentWrap {
      width: 49%;
      height: 100%;
      @include setFlexColumn;
      justify-content: space-between;
      .listBox {
        width: 97%;
        height: 8%;
        margin: 0 auto;
        @include setFlexBetween;
        li {
          width: 24%;
          height: 100%;
          background: url("~@/assets/images/guangfu/miniWrap.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          h5 {
            color: #fff;
            font-size: 20px;
            margin: 0 10px;
          }
          p {
            color: #16e9f4;
            span {
              display: block;
              color: #868b99;
              font-size: 12px;
            }
          }
        }
      }
      .imgBox {
        width: 100%;
        // height: 63%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .analysis {
        width: 97%;
        height: 25%;
        margin: 0 auto;
        .ringBox {
          width: 40%;
          height: 90%;
        }
        .lineBox {
          width: 60%;
          height: 90%;
        }
      }
    }
    .rightWrap {
      width: 25%;
      height: 100%;
      @include setFlexColumn;
      justify-content: space-between;
      .meteorological {
        width: 100%;
        height: 28%;
        ul {
          width: 95%;
          height: 90%;
          margin: 0 auto;
          @include setFlexCenter;
          flex-wrap: wrap;
          li {
            width: 24%;
            margin-right: 1%;
            padding: 10px 0;
            text-align: center;
            p {
              color: #b4b8bd;
            }
            h5 {
              color: #16e9f4;
              font-weight: 500;
              font-size: 15px;
              margin-top: 10px;
            }
          }
        }
      }
      .giveAlarm {
        width: 100%;
        height: 37%;
      }
      .ecData {
        width: 100%;
        height: 33%;
      }
    }
  }
}
</style>
